var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInformation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4765 8.85938C13.3296 8.85938 14.8487 10.3134 14.9479 12.1381L14.953 12.3281V15.8438C14.953 16.3615 14.5324 16.7812 14.0134 16.7812C13.5316 16.7812 13.1344 16.4193 13.0801 15.9531L13.0738 15.8438V12.3281C13.0738 11.4493 12.3573 10.7344 11.4765 10.7344C10.6447 10.7344 9.95932 11.3721 9.88573 12.1833L9.87919 12.3281V20.5312C9.87919 21.4101 10.5957 22.125 11.4765 22.125C12.3084 22.125 12.9937 21.4873 13.0673 20.6761L13.0738 20.5312C13.0738 20.0135 13.4945 19.5938 14.0134 19.5938C14.5324 19.5938 14.953 20.0135 14.953 20.5312C14.953 22.4439 13.3935 24 11.4765 24C9.62344 24 8.10437 22.5459 8.00515 20.7213L8 20.5312V12.3281C8 10.4154 9.55954 8.85938 11.4765 8.85938ZM11.5235 0C13.4405 0 15 1.55606 15 3.46875C15 5.38144 13.4405 6.9375 11.5235 6.9375C9.60652 6.9375 8.04698 5.38144 8.04698 3.46875C8.04698 1.55606 9.60652 0 11.5235 0ZM11.5235 1.875C10.6427 1.875 9.92617 2.58994 9.92617 3.46875C9.92617 4.34756 10.6427 5.0625 11.5235 5.0625C12.4043 5.0625 13.1208 4.34756 13.1208 3.46875C13.1208 2.58994 12.4043 1.875 11.5235 1.875Z",
    fill: "#2D6CE6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInformation);
export default __webpack_public_path__ + "static/media/information.461c33d2138dcbeb76d09dac8ae1d19e.svg";
export { ForwardRef as ReactComponent };